export default {
    token: localStorage.getItem("user-token") || "",
    roles: localStorage.getItem("user-roles") || "",
    status: "",
    user: localStorage.getItem("user-name") || "",
    claims: localStorage.getItem("user-claims") || "",
    isAdmin: localStorage.getItem("user-isAdmin") || false,
    utaPhone: localStorage.getItem("user-uta-phone") || "",
    branch: localStorage.getItem("branch") || "",
    plivoPhone: localStorage.getItem("user-plivo-phone") || "",
    emailAddress: localStorage.getItem("user-email") || "",
};
